import { j as json } from "../../../../chunks/index.js";
import { createRequire } from "module";
const require2 = createRequire(import.meta.url);
const { PrismaClient } = require2("@prisma/client");
const prisma = new PrismaClient();
const GET = async () => {
  const forms = await prisma.form.findMany();
  return json(forms);
};
export {
  GET
};
